module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTooltip),
      expression: "showTooltip"
    }],
    staticClass: "tooltip"
  }, [_c('span', {
    staticClass: "tooltipText"
  }, [_c('span', [_vm._v(_vm._s(_vm.text))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1487d9c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tooltip/tooltip.vue
// module id = 63
// module chunks = 0